import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "petualangan_bayi_state_v1";

const defaultState = {
  language: "id", // 'id' | 'en'
  soundOn: true,
  musicOn: false,
  parentId: null,
  email: null,
  activeChildId: null,
  stars: 0,
  researchMode: true,
  isPremium: false,
  hasFullAccess: false,
  unlockedLayers: [],
  isInvestor: false,
  investorSlots: 0,
  parentToken: null,
};

const getInitialState = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      return { ...defaultState, ...JSON.parse(raw) };
    }
  } catch (err) {
    console.warn("Failed to load initial game state from localStorage:", err);
  }
  return defaultState;
};

const gameSlice = createSlice({
  name: "game",
  initialState: getInitialState(),
  reducers: {
    updateState: (state, action) => {
      Object.assign(state, action.payload);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (err) {
        console.warn("Failed to persist game state:", err);
      }
    },
    addStars: (state, action) => {
      state.stars += action.payload ?? 1;
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (err) {
        console.warn("Failed to persist game state:", err);
      }
    },
    toggleLanguage: (state) => {
      state.language = state.language === "id" ? "en" : "id";
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (err) {
        console.warn("Failed to persist game state:", err);
      }
    },
    toggleSound: (state) => {
      state.soundOn = !state.soundOn;
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (err) {
        console.warn("Failed to persist game state:", err);
      }
    },
    toggleMusic: (state) => {
      state.musicOn = !state.musicOn;
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (err) {
        console.warn("Failed to persist game state:", err);
      }
    },
    toggleResearchMode: (state) => {
      state.researchMode = !state.researchMode;
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (err) {
        console.warn("Failed to persist game state:", err);
      }
    },
    togglePremium: (state) => {
      state.isPremium = !state.isPremium;
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (err) {
        console.warn("Failed to persist game state:", err);
      }
    },
    clearState: (state) => {
      Object.assign(state, defaultState);
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (err) {
        console.warn("Failed to clear game state:", err);
      }
    },
  },
});

export const {
  updateState,
  addStars,
  toggleLanguage,
  toggleSound,
  toggleMusic,
  toggleResearchMode,
  togglePremium,
  clearState,
} = gameSlice.actions;

export default gameSlice.reducer;
